<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Annie Villiers lives and works in the Central Otago region of Aotearoa New Zealand. She has previously published two poetry collections, in collaboration with artist John Z Robinson, and a novel set in New Zealand and Greece. Her writing reflects a deep sense of connection to the physical landscape and to the wider landscape of belonging; physical and metaphysical. Her writing celebrates the whenua (land) the tangata (people) and the stories that connect them.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?238c0259